import React from 'react';

/**
 * Skeleton placeholder for loading states.
 * @param {string} className - Additional Tailwind classes
 * @param {string} variant - 'text' | 'circular' | 'rectangular' (default: rectangular)
 */
const Skeleton = ({ className = '', variant = 'rectangular' }) => {
  const baseClasses = 'skeleton';
  const variantClasses = {
    text: 'h-4 rounded',
    circular: 'rounded-full aspect-square',
    rectangular: 'rounded-lg'
  };
  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
